(function () {
    // Apple service wrapper
    SUGApp.service('appleService', ['$q', '$window', 'SUGUtilities', function ($q, $win, util) {
        var service = {
            appleConnected: false,
            appleLoading: false
        };

        var setAppleConnected = function (connected) {
            service.appleConnected = connected ? true : false;
        };

        var setAppleLoading = function (processing) {
            service.appleLoading = processing ? true : false;
        };

        setAppleConnected(false);
        setAppleLoading(true);

        const clientId = window.globalcfg.appleClientid;
        const redirectURI = window.globalcfg.redirectURI;

        // Method to initialize Apple Authentication
        service.initApple = function () {
            if (typeof AppleID !== 'undefined') {
                AppleID.auth.init({
                    clientId: clientId,
                    scope: 'name email', // Specify the scope you need
                    redirectURI: redirectURI, // Specify your redirect URI
                    usePopup : true
                });
            }
        };

        // This needs to run once you know you have the Apple Authentication SDK available
        var setupApple = function () {
            setAppleLoading(false);
            // Manually initialize Apple Authentication
            service.initApple();
        };

        if (typeof AppleID === 'undefined') {
            // Apple Authentication SDK not loaded yet, so load it asynchronously
            var script = document.createElement('script');
            script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
            script.onload = setupApple;
            document.head.appendChild(script);
        } else {
            // Apple Authentication SDK is already loaded, so proceed
            setupApple();
        }

        // Apple sign in
        service.appleSignIn = function () {
            var deferred = $q.defer();

            if (typeof AppleID === 'undefined') {
                // Still loading, can't do anything
                deferred.reject('Apple Authentication SDK is still loading');
            } else {
                // Apple Authentication SDK present, good to go
                setAppleLoading(true);

                AppleID.auth.signIn().then(function (response) {
                    if (response?.authorization?.id_token) {
                        setAppleConnected(true);
                        deferred.resolve(response);
                    } else {
                        setAppleLoading(false);
                        setAppleConnected(false);
                        deferred.reject('Error occurred during Apple sign in');
                    }
                });
            }

            return deferred.promise;
        };

        // Return service object
        return service;
    }]);
})();